import React from "react";
import { Button, ButtonGroup, DatePicker, Input, Modal, Select, Toast } from "../../";
import { useState } from "react";
import moment from "moment";
import { apis, post } from "../../../Utils/axios";
import { COUNTRIES } from "../../../Utils/constants";
import { validatePhoneNumber } from "Utils/utils";

function AddGuest({ onReload = () => {}, btnLabel = "+ Add Guest", btnVariant = "primary", btnClass = "" }) {
	const [NewGuest, setNewGuest] = useState();
	const initial = {
		fName: "",
		lName: "",
		email: "",
		phone: "",
		phoneCode: {},
		gender: {
			label: "Male",
			value: "MALE",
		},
		dob: moment().subtract(18, "years").valueOf(),
	};
	const [Values, setValues] = useState(initial);
	const [Loader, setLoader] = useState();

	const onSubmit = async () => {
		if (!Values.fName || !Values.lName) {
			return Toast.error("Please enter first and last name");
		}
		if (!Values.gender) {
			return Toast.error("Please select gender");
		}
		if (!Values.email) {
			return Toast.error("Please enter email address");
		}
		if (!Values.dob) {
			return Toast.error("Please select date of birth");
		}
		setLoader(true);
		const isValid = await validatePhoneNumber(Values.phone, Values.phoneCode.value);
		if (!isValid) {
			setLoader(false);
			return Toast.error("Please enter valid phone number");
		}

		post(
			apis.addGuest,
			{
				...Values,
				gender: Values.gender?.value,
				dob: moment(Values.dob).format("YYYY-MM-DD"),
				phoneCode: Values.phoneCode?.value,
			},
			(r, e) => {
				if (r) {
					Toast.success("Guest added");
					setNewGuest(false);
					setLoader(false);
					onReload();
					setValues(initial);
				} else if (e) {
					Toast.handleError(e);
					setLoader(false);
				}
			}
		);
	};

	return (
		<>
			<Button onClick={() => setNewGuest(true)} variant={btnVariant} className={btnClass}>
				{btnLabel}
			</Button>
			<Modal open={NewGuest} onClose={() => setNewGuest()}>
				<div className="p-6">
					<h1>New Guest</h1>
					<div className="mt-4 space-y-4">
						<div className="grid grid-cols-2 gap-x-4">
							<Input noNumbers required value={Values.fName} onChange={(fName) => setValues((prev) => ({ ...prev, fName }))} label="First Name" placeholder="First Name" />
							<Input noNumbers required value={Values.lName} onChange={(lName) => setValues((prev) => ({ ...prev, lName }))} label="Last Name" placeholder="Last Name" />
						</div>
						<Input required value={Values.email} onChange={(email) => setValues((prev) => ({ ...prev, email }))} label="Email" placeholder="Email Address" />
						<div>
							<label>Phone Number</label>
							<div className="flex gap-2 mt-2">
								<Select className="max-w-min" placeholder="Code" selected={Values.phoneCode} onChange={(phoneCode) => setValues((prev) => ({ ...prev, phoneCode }))} required label="" options={COUNTRIES} />
								<Input className="flex-1" type="number" required value={Values.phone} onChange={(phone) => setValues((prev) => ({ ...prev, phone }))} placeholder="Phone" />
							</div>
						</div>
						<div className="grid grid-cols-2 mt-4 gap-x-4">
							<DatePicker maxDate={moment().valueOf()} backDateSelection={true} date={Values.dob} setDate={(dob) => setValues((prev) => ({ ...prev, dob }))} label="Date of Birth" />
							<div>
								<label className="block mb-2">Gender</label>
								<ButtonGroup
									selected={Values.gender}
									onClick={(gender) => setValues((prev) => ({ ...prev, gender }))}
									options={[
										{
											label: "Male",
											value: "MALE",
										},
										{
											label: "Female",
											value: "FEMALE",
										},
									]}
								/>
							</div>
						</div>
						<Button onClick={onSubmit} loading={Loader} className="w-full mt-4">
							Add Guest
						</Button>
					</div>
				</div>
			</Modal>
		</>
	);
}

export default AddGuest;
